import React, { useState, useEffect } from "react";
import { Form, DatePicker, Typography, Checkbox } from "antd";

const { Text } = Typography;

const ActualDate = (props) => {
  const [actualDateDisplay, setActualDateDisplay] = useState(props.display);

  const enableActualDate = (e) => {
    setActualDateDisplay(e.target.checked);
  };

  const error = props.validationError.actualError ? (
    <Text type="danger">{props.validationError.actualError}</Text>
  ) : null;

  return (
    <React.Fragment>
      {!props.display ? (
        <Checkbox
          className="transparentBG actualdateCheckbox"
          checked={actualDateDisplay}
          onChange={enableActualDate}
        >
          Enable Actual Date
        </Checkbox>
      ) : null}
      {actualDateDisplay ? (
        <>
          <p
            style={{
              marginTop: "20px",
              color: "rgba(255, 255, 255, 0.65)",
              fontSize: "18px",
              marginBottom: "5px",
            }}
          >
            Actual Dates:
          </p>
          {error}
          <Form.Item
            name="ActualSeriesFrom"
            label="Actual From Date"
            placeholder="Select Actual From Date"
            rules={[
              { required: true, message: "Please Select Actual From Date !" },
            ]}
          >
            <DatePicker
              style={{ minHeight: 40 }}
              className="gx-mb-3 gx-w-100 custom-pink-bg-color"
              placeholder="Select Actual Date"
              onChange={props.handleChangeEvent}
            />
          </Form.Item>
          <Form.Item
            name="ActualSeriesTo"
            label="Actual To Date"
            placeholder="Select Actual to Date"
            rules={[
              { required: true, message: "Please Select Actual To Date !" },
            ]}
          >
            <DatePicker
              style={{ minHeight: 40 }}
              className="gx-mb-3 gx-w-100 custom-pink-bg-color"
              placeholder="Select Actual Date"
              onChange={props.handleChangeEvent}
            />
          </Form.Item>
        </>
      ) : null}
    </React.Fragment>
  );
};

export default ActualDate;
